module.exports = __webpack_public_path__ + "static/extra_5-5a9195aff284d6fcc82450afc8811ef2.jpg";